import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@qaroni-app/app.config';
import { sentryInit } from '@qaroni-core/config/app/sentry/sentry.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  sentryInit();
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
